<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
  },
  data() {
    return {

    }
  }
}
</script>

<template>
  <div class="baseBannerTitle container">
    <span class="baseBannerTitle__subTitle font-cursive ls-0">{{subTitle}}</span>
    <h2 class="baseBannerTitle__title" v-html="title"></h2>
  </div>
</template>
<style lang="scss">
  .baseBannerTitle {
    position: relative;
    color:$color-white;
    @include max-lg {
      text-align: center;
    }
    &__subTitle {
      font-size: 28px;
      @include max-md {
        font-size: 21px;
      }
    }
    &__title {
      font-size: 50px;
      font-weight: 600;
       @include max-md {
        font-size: 30px;
      }
      // line-height: 1.5;
    }
    // &.isStyleDecoration {
    //   position: relative;
    //   &:before {
    //     position: absolute;
    //     content: url('~@assets/images/home/line.svg');
    //     bottom: -24px;
    //     left: 0;
    //   }
    //   &.isCenter {
    //     &:before {
    //       right: 0;
    //       left: 0;
    //     }
    //   }
    // }
  }
</style>